module.exports = __webpack_public_path__ + "img/platform_html.410419cc.svg";